<template>
  <v-app light>
      <PrivateLayout />
  </v-app>
</template>

<script>
import PrivateLayout from './components/PrivateLayout'
import PublicLayout from './components/PublicLayout'

export default {
  name: "App",
  components: {
    PrivateLayout,
    PublicLayout
  },
  data: () => ({
    drawer: null,
    navBarOptions: {
      nomeLg: "Projetos Simplifica",
      nomeSm: "Projetos Simplifica"
    }
  }),
  computed: {
    authenticated() {
      return this.$store.state.authenticated;
    },
    isPublic() {
      return this.$store.state.route.meta && !this.$store.state.route.meta.permission
    }
  }
};
</script>
 